<div *ngIf="myClass !== null">

  <div class="my-input-div" *ngIf="cellType === 'checkbox'">
    <div class="my-input-checkbox">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }}</label>
      <input class="checkbox" [defaultChecked]="model[name]" id="{{ name }}" type="{{ cellType }}" name="{{ name }}" [required]="required" (click)="setCheckBox($event)">
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'text'">
    <div class="my-input {{ disabled ? 'disabled' : '' }}">
      <label class="{{ label }}" for="{{ name }}">
        {{ myClass.langBase + label | translatePipe }}
        <!-- span *ngIf="label === 'work_area'"> {{ 'landing.form.work_area_placeholder' | translatePipe }}</span -->
      </label>
      <input id="{{ name }}" type="{{ cellType }}" placeholder="{{ myClass.langBase + label | translatePipe }}" name="{{ name }}" [disabled]="disabled" [required]="required" [(ngModel)]="model[name]">
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'documentType'">
    <app-field-form-select-document-type [name]="name" [required]="required" [label]="label" [myClass]="myClass"></app-field-form-select-document-type>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'tenant'">
    <app-field-form-select-tenant [name]="name" [required]="required" [label]="label" [myClass]="myClass"></app-field-form-select-tenant>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'hiringCompany'">
    <app-field-form-select-hiring-company [name]="name" [required]="required" [label]="label" [myClass]="myClass"></app-field-form-select-hiring-company>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'gender'">
    <app-field-form-select-gender [name]="name" [required]="required" [label]="label" [myClass]="myClass"></app-field-form-select-gender>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'isActive'">
    <app-field-form-select-active [name]="name" [required]="required" [label]="label" [myClass]="myClass"></app-field-form-select-active>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'rolGroup'">
    <app-field-form-select-rol-group [name]="name" [required]="required" [label]="label" [myClass]="myClass"></app-field-form-select-rol-group>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'userRoles'">
    <app-field-form-select-user-rol [name]="name" [required]="required" [label]="label" [myClass]="myClass"></app-field-form-select-user-rol>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'workScheduleTypeID'">
    <app-field-form-select-work-schedule-type [name]="name" [required]="required" [label]="label" [myClass]="myClass" [filter]="filter"></app-field-form-select-work-schedule-type>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'locationID'">
    <app-field-form-select-location [name]="name" [required]="required" [label]="label" [myClass]="myClass" [filter]="filter" (changeAction)="onChage($event)"></app-field-form-select-location>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'scheduledToID'">
    <app-field-form-select-employee [name]="name" [required]="required" [label]="label" [myClass]="myClass" [filter]="filter"></app-field-form-select-employee>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'latlong'">
    <app-field-form-latlong [centerLatLng]="centerLatLng" [myClass]="myClass" [name]="name" (setAction)="onChage($event)"></app-field-form-latlong>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'latlongTxt'">
    <div class="my-input {{ disabled ? 'disabled' : '' }}">
      <label class="{{ label }}" for="{{ name }}">
        {{ myClass.langBase + label | translatePipe }}
        <!-- span *ngIf="label === 'work_area'"> {{ 'landing.form.work_area_placeholder' | translatePipe }}</span -->
      </label>
      <input id="{{ name }}" type="{{ cellType }}" placeholder="{{ myClass.langBase + label | translatePipe }}" name="{{ name }}" [disabled]="disabled" [required]="required" [(ngModel)]="model[name]" (change)="onChage($event)">
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'number'">
    <div class="my-input">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }}</label>
      <input type="{{ cellType }}" name="{{ name }}" [required]="required" [(ngModel)]="model[name]">
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'button'">
    <app-button [text]="myClass.langBase + label | translatePipe" [type]="'button'"></app-button>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'email'">
    <div class="my-input">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }}</label>
      <input type="{{ cellType }}" name="{{ name }}" [required]="required" [(ngModel)]="model[name]">
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'password'">
    <div class="my-input">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }}</label>
      <input type="{{ cellType }}" name="{{ name }}" [required]="required" [(ngModel)]="model[name]">
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'date'">
    <div class="my-input">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }}</label>
      <input type="{{ cellType }}" name="{{ name }}" [required]="required" [(ngModel)]="model[name]">
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'datetime'">
    <div class="my-input dateTime">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }}</label>
      <!-- input type="datetime-local" [value]="model[name] | date: 'dd/MM/yyyy h:mm a'" min="{{ setMinDateTime() }}" name="{{ name }}" [required]="required" [(ngModel)]="model[name]" (change)="setDateTime($event)" -->
      <input type="datetime-local" min="{{ setMinDateTime() }}" name="{{ name }}" [required]="required" [(ngModel)]="model[name]" (change)="setDateTime($event)" >
    </div>
  </div>

  <div class="my-input-div" *ngIf="cellType === 'image'">
    <div class="my-input">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }}</label>
      <input (change)="selectFile($event, name)" #fileInput type="file" id="file" accept="image/*">
    </div>
  </div>


  <div class="my-input-div" *ngIf="cellType === 'signature'">
    <div class="my-input-canva" id="canvas-div">
      <div class="{{ canvasIsClear ? 'active' : 'inactive'  }}"><img src="{{ images.signature }}"><p>{{ myClass.langBase + label | translatePipe }}</p></div>
      <canvas width="{{ whatIsMyWidth() }}" height="300" class="signature"></canvas>
    </div>
    <div class="button-div">
      <button id="canvasCancel" class="my-button {{ !canvasIsClear ? 'active' : 'inactive' }}">{{ 'landing.form.cancel' | translatePipe }}</button>
      <button id="canvasApply" class="my-button {{ !canvasIsClear ? 'active' : 'inactive' }}">{{ 'landing.form.apply' | translatePipe }}</button>
    </div>
  </div>

  <div class="my-input-div" [ngSwitch]="cellType" *ngIf="!specialFields.includes(cellType)">
    <div class="my-input">
      <label for="{{ name }}">{{ myClass.langBase + label | translatePipe }} <span class="mat-error">{{ required ? '*' : '' }}</span></label>
      <!-- label *ngIf="model[name].length === 0 && cellType !== 'textarea'" for="{{ name }}">{{ label }} <span class="mat-error">{{ required ? '*' : '' }}</span></label -->
      <textarea id="{{ name }}" *ngSwitchCase="'textarea'" placeholder="Escribe aquí tus comentarios" [value]="model[name]" (keyup)="setTextarea($event)" maxlength="500"></textarea>
      <p class="count-textarea" *ngSwitchCase="'textarea'">{{ model[name].length }} / 500</p>
      <input class="" id="{{ name }}" placeholder="{{ label }}"  *ngSwitchCase="'text-string'" type="text" [(ngModel)]="model[name]" name="{{ name }}" [required]="required" pattern="[A-zÀ-ú\s]*">
      <input class="" id="{{ name }}" placeholder="{{ label }}"  *ngSwitchCase="'phone'" type="tel" [maxLength]="10" [minLength]="10" [(ngModel)]="model[name]" name="{{ name }}" [required]="required" pattern="[0-9]*">
      <input class="" id="{{ name }}" placeholder="{{ label }}" *ngSwitchDefault type="{{ cellType }}" [(ngModel)]="model[name]" name="{{ name }}" [required]="required">
    </div>
  </div>

</div>
